import logSystemUtil from '../../../logs/redux/actions/log'
import addInstanceToDomainListReduxUtil from '../../../redux/utils/add-instance-to-domain-list'
import getClassNameReduxUtil from '../../../redux/utils/get-class-name'
import getDomainListPathsReduxUtil from '../../../redux/utils/get-domain-list-path'
import removeInstanceFromDomainListsReduxUtil from '../../../redux/utils/remove-instance-from-domain-lists'
import shouldAddToDomainListReduxUtil from '../../../redux/utils/should-add-to-domain-list'

export default function addInstanceToDomainListsReduxUtil (data) {
  let {
    state,
    existingInstance,
    instance,
    domainListPath,
    options
  } = data

  if (existingInstance) {
    state = removeInstanceFromDomainListsReduxUtil({
      instance: existingInstance,
      state
    })
  }

  const propsToPass = { instance, state, domainListPath }
  const domainListPaths = getDomainListPathsReduxUtil(propsToPass)
  domainListPaths.forEach(dmPath => {
    const shouldAdd = shouldAddToDomainListReduxUtil({ ...propsToPass, domainListPath: dmPath })
    if (!shouldAdd) {
      logSystemUtil('addInstanceToDomainListsReduxUtil').debug(`${logPrefix} [noop] should not add`)
      return
    }
    state = addInstanceToDomainListReduxUtil({
      state,
      instance,
      domainListPath: dmPath,
      options
    })
  })

  const logPrefix = `className=${getClassNameReduxUtil(instance)}`
  logSystemUtil('addInstanceToDomainListsReduxUtil').debug(`${logPrefix} domainListPaths=`, domainListPaths)
  return state
}
